import DropdownOptionWithIcon from "components/Menus/DropdownOptionWithIcon";
import { callFunctionIfExists } from "utils/GeneralUtils";
import PopoverDropdownMenu from "components/Menus/PopoverDropdownMenu";

const MemberOptions = ({
  member,
  isOwner,
  isCurrentUser,
  wPermissions,
  removeMember,
  setTransferUser,
  setManageUser,
  closeWhisper,
}) => {
  return (
    <PopoverDropdownMenu>
      <DropdownOptionWithIcon
        name="Manage Permissions"
        onClick={() => {
          setManageUser(member.Data);
          callFunctionIfExists(closeWhisper);
        }}
        icon="mdi mdi-pencil"
        disabled={
          isCurrentUser || isOwner || !wPermissions.workspace_modify_user
        }
      />
      <DropdownOptionWithIcon
        name="Set As Owner"
        onClick={() => {
          setTransferUser(member.Data);
          callFunctionIfExists(closeWhisper);
        }}
        icon="mdi mdi-crown"
        disabled={
          !wPermissions.workspace_transfer_workspace_ownership ||
          isOwner === true
        }
      ></DropdownOptionWithIcon>
      <DropdownOptionWithIcon
        name="Remove Member"
        onClick={() => {
          removeMember(
            member.PersonID,
            member?.Data?.Name || member?.Data?.PrimaryContactEmail
          );
          callFunctionIfExists(closeWhisper);
        }}
        icon="mdi mdi-delete"
        disabled={
          isCurrentUser || isOwner || !wPermissions.workspace_delete_user
        }
      ></DropdownOptionWithIcon>
    </PopoverDropdownMenu>
  );
};

export default MemberOptions;
